/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ContentCopy, DeleteOutlined, ModeEditOutlineOutlined } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { LinkContext } from "cms/links/link-selector/context";
import { useContext, useEffect, useState } from "react";
import { formatDate } from "utils/date-format";

const LinkDialogPreviewPanel = () => {

    const {
        selectedLink,
        onEdit,
        onClone,
        onDelete,
    } = useContext(LinkContext);

    let {
        text,
        url,
        link_type,
        updated_at,
    } = selectedLink || {};

    const lastUpdated = formatDate(updated_at);
    const [linkUrl, setLinkUrl] = useState("");

    useEffect(() => {
        if (selectedLink) {
            setLinkUrl(selectedLink.url);
        }
    }, [selectedLink]);
    const handleEdit = () => {
        onEdit();
    };
    const handleClone = () => {
        onClone();
    };
    const handleDelete = () => {
        // TODO: Convert this to an are you sure dialog
        if (window.confirm("You are about to delete this link, affecting any pages it was used on. Please Confirm.")) {
            onDelete(selectedLink);
        }
    };

    if (!linkUrl) {

        return (
            <div className="simplicity-link-selector-window-preview-none">
                No link selected
            </div>
        );

    } else {

        return (
            <>
                {linkUrl &&
                    <div className="simplicity-link-selector-window-preview">
                        <div className="simplicity-link-selector-edit">

                            <div className="simplicity-link-selector-edit-header">
                                Details
                            </div>

                            <div className="simplicity-link-selector-edit-panel">

                                <div className="simplicity-link-selector-edit-panel-buttons">
                                    <Button
                                        variant='outlined'
                                        color='secondary'
                                        size='small'
                                        title={"Edit link"}
                                        onClick={handleEdit}
                                        startIcon={<ModeEditOutlineOutlined color='secondary' />}
                                    >
                                        Edit
                                    </Button>
                                    <IconButton
                                        size='small'
                                        title={"Duplicate link"}
                                        edge='end'
                                        onClick={handleClone}
                                    >
                                        <ContentCopy />
                                    </IconButton>
                                    <IconButton
                                        size='small'
                                        title={"Delete link"}
                                        edge='end'
                                        onClick={handleDelete}
                                    >
                                        <DeleteOutlined />
                                    </IconButton>
                                </div>

                                <div className="summary-details">
                                    <p className='detail-property'>
                                        <span className='detail-property-key'>Link Text: </span>
                                        {" "}{selectedLink && text}
                                    </p>
                                    <p className='detail-property'>
                                        <span className='detail-property-key'>URL: </span>
                                        {" "}{selectedLink && url}
                                    </p>
                                    <p className='detail-property'>
                                        <span className='detail-property-key'>Link Type: </span>
                                        {" "}{selectedLink && link_type}
                                    </p>
                                    <p className='detail-property'>
                                        <span className='detail-property-key'>Last Updated: </span>
                                        {" "}{selectedLink && lastUpdated}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
};

export { LinkDialogPreviewPanel };
